module.exports = __webpack_public_path__ + "img/ytichead.2a5f7e19.png";